import type { ReactNode } from 'react';
import './DesktopSplit.scss';

type DesktopRatio = '50-50' | '60-40' | '40-60';

/**
 * Two-pane layout used on /id-card, /photo, /welcome.
 * - Mobile: stacked vertically (left pane on top), unless `mobileHide` is set
 *   to drop one pane entirely below the desktop breakpoint.
 * - Desktop: side-by-side, default 50/50; pass `desktopRatio` to skew, e.g.
 *   form fill = 60/40, photo step = 40/60. The split panes carry stable
 *   `view-transition-name`s so the size change animates between routes.
 */
export default function DesktopSplit({
  left,
  right,
  mobileHide,
  desktopRatio = '50-50',
}: {
  left: ReactNode;
  right: ReactNode;
  mobileHide?: 'left' | 'right';
  desktopRatio?: DesktopRatio;
}) {
  const className = [
    'split',
    `split--ratio-${desktopRatio}`,
    mobileHide && `split--hide-${mobileHide}-mobile`,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={className}>
      <section className="split__left">{left}</section>
      <section className="split__right">{right}</section>
    </div>
  );
}
